import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useApiError } from '@/modules/common/hooks/use-api-error';

import { deleteReport } from '../api/reports.api';
import { REPORTS_QUERY_KEY } from '../constants/reports-query-keys';

export const useDeleteReport = () => {
  const queryClient = useQueryClient();
  const { displayToastErrorFromApiWithFallback } = useApiError();

  return useMutation({
    mutationFn: (id: string) => deleteReport(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: REPORTS_QUERY_KEY });
    },
    onError: error => {
      displayToastErrorFromApiWithFallback(error, 'authenticated.reports:toasts.deleteError');
    },
  });
};
